import React, { useState } from 'react';
import { HomeIcon, HomeIcon as LandIcon, DollarSignIcon, BriefcaseIcon, TrashIcon, DropletIcon, ShieldIcon, UsersIcon, ActivityIcon, BookIcon, LeafIcon, SettingsIcon, ChevronLeftIcon, ChevronRightIcon, BoxIcon, CarIcon, SirenIcon, LandmarkIcon, ChevronDownIcon, WrenchIcon, LayoutGridIcon, ClipboardListIcon, BookOpenIcon, ListIcon, PackageIcon, BarChart2Icon, CheckSquareIcon } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useNavigation } from '../../context/NavigationContext';
interface SidebarProps {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  onNavigate: (path: string) => void;
  currentPath: string;
}
export const Sidebar = ({
  collapsed,
  setCollapsed
}: {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}) => {
  const {
    isAuthenticated,
    is2FAVerified
  } = useAuth();
  const {
    currentPath,
    navigate
  } = useNavigation();
  const [adminMenuOpen, setAdminMenuOpen] = useState(false);
  if (!isAuthenticated || !is2FAVerified) {
    return <></>;
  }
  const menuItems = [{
    name: 'Dashboard',
    icon: HomeIcon,
    path: '/',
    active: currentPath === '/'
  }, {
    name: 'My Tasks',
    icon: BoxIcon,
    path: '/tasks',
    count: 7,
    active: currentPath === '/tasks'
  }, {
    name: 'Lists',
    icon: LayoutGridIcon,
    path: '/lists',
    active: currentPath === '/lists'
  }, {
    name: 'Applications',
    icon: LandIcon,
    path: '/land-property',
    active: currentPath === '/land-property'
  }, {
    name: 'Taxes & Revenue',
    icon: DollarSignIcon,
    path: '/taxes-revenue',
    active: currentPath === '/taxes-revenue'
  }, {
    name: 'Business Licensing',
    icon: BriefcaseIcon,
    path: '/business-licensing',
    active: currentPath === '/business-licensing'
  }, {
    name: 'Waste Management',
    icon: TrashIcon,
    path: '/waste-management',
    active: currentPath === '/waste-management'
  }, {
    name: 'Water & Sanitation',
    icon: DropletIcon,
    path: '/water-sanitation',
    active: currentPath === '/water-sanitation'
  }, {
    name: 'Infrastructure',
    icon: BoxIcon,
    path: '/infrastructure',
    active: currentPath === '/infrastructure'
  }, {
    name: 'Public Safety',
    icon: ShieldIcon,
    path: '/public-safety',
    active: currentPath === '/public-safety'
  }, {
    name: 'Civil Registry',
    icon: UsersIcon,
    path: '/civil-registry',
    active: currentPath === '/civil-registry'
  }, {
    name: 'Health Services',
    icon: ActivityIcon,
    path: '/health-services',
    active: currentPath === '/health-services'
  }, {
    name: 'Education',
    icon: BookIcon,
    path: '/education',
    active: currentPath === '/education'
  }, {
    name: 'Environmental',
    icon: LeafIcon,
    path: '/environmental',
    active: currentPath === '/environmental'
  }, {
    name: 'Immigration & Residency',
    icon: BoxIcon,
    path: '/immigration-residency',
    active: currentPath === '/immigration-residency'
  }, {
    name: 'Agriculture & Resources',
    icon: BoxIcon,
    path: '/agriculture-resources',
    active: currentPath === '/agriculture-resources'
  }, {
    name: 'Culture & Recreation',
    icon: BoxIcon,
    path: '/culture-recreation',
    active: currentPath === '/culture-recreation'
  }, {
    name: 'Transportation',
    icon: CarIcon,
    path: '/transportation',
    active: currentPath === '/transportation'
  }, {
    name: 'Emergency Services',
    icon: SirenIcon,
    path: '/emergency-services',
    active: currentPath === '/emergency-services'
  }, {
    name: 'Civic Engagement',
    icon: LandmarkIcon,
    path: '/civic-engagement',
    active: currentPath === '/civic-engagement'
  }, {
    name: 'Reports',
    icon: BoxIcon,
    path: '/reports',
    active: currentPath === '/reports'
  }];
  const adminMenuItems = [{
    name: 'Users',
    icon: UsersIcon,
    path: '/admin/users',
    active: currentPath === '/admin/users'
  }, {
    name: 'Services Configuration',
    icon: BoxIcon,
    path: '/admin/services',
    active: currentPath === '/admin/services'
  }, {
    name: 'Workflow Configuration',
    icon: BoxIcon,
    path: '/admin/workflow',
    active: currentPath === '/admin/workflow'
  }, {
    name: 'Settings',
    icon: SettingsIcon,
    path: '/settings',
    active: currentPath === '/settings'
  }];
  const isAdminMenuActive = adminMenuItems.some(item => item.path === currentPath);
  return <div className={`bg-white border-r border-gray-200 transition-all duration-200 flex flex-col h-full ${collapsed ? 'w-16' : 'w-64'}`} data-id="element-285">
      <div className="flex-1 overflow-y-auto py-4" data-id="element-286">
        <ul className="space-y-1 px-2" data-id="element-287">
          {menuItems.map((item, index) => <li key={index} data-id="element-288">
              <button onClick={() => navigate(item.path)} className={`w-full flex items-center px-3 py-2.5 text-sm rounded-md group ${item.active ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-289">
                <div className="flex items-center min-w-0 flex-1" data-id="element-290">
                  {item.name === 'Lists' ? <ClipboardListIcon className={`h-5 w-5 flex-shrink-0 ${item.active ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-291" /> : item.name === 'Applications' ? <LayoutGridIcon className={`h-5 w-5 flex-shrink-0 ${item.active ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-292" /> : item.name === 'Reports' ? <BarChart2Icon className={`h-5 w-5 flex-shrink-0 ${item.active ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-293" /> : item.name === 'My Tasks' ? <CheckSquareIcon className={`h-5 w-5 flex-shrink-0 ${item.active ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-294" /> : <item.icon className={`h-5 w-5 flex-shrink-0 ${item.active ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-295" />}
                  {!collapsed && <span className="ml-3 truncate" data-id="element-296">
                      {item.name === 'Lists' ? 'Service Catalogue' : item.name}
                    </span>}
                </div>
              </button>
            </li>)}
          {/* Administration Menu */}
          <li data-id="element-297">
            <button onClick={() => !collapsed && setAdminMenuOpen(!adminMenuOpen)} className={`w-full flex items-center px-3 py-2.5 text-sm rounded-md group ${isAdminMenuActive ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-298">
              <div className="flex items-center min-w-0 flex-1" data-id="element-299">
                <WrenchIcon className={`h-5 w-5 flex-shrink-0 ${isAdminMenuActive ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-300" />
                {!collapsed && <>
                    <span className="ml-3 truncate" data-id="element-301">Administration</span>
                    <ChevronDownIcon className={`ml-auto h-4 w-4 transition-transform ${adminMenuOpen ? 'transform rotate-180' : ''}`} data-id="element-302" />
                  </>}
              </div>
            </button>
            {/* Admin Sub-menu */}
            {!collapsed && adminMenuOpen && <ul className="mt-1 pl-8 space-y-1" data-id="element-303">
                {adminMenuItems.map((item, index) => <li key={index} data-id="element-304">
                    <button onClick={() => navigate(item.path)} className={`w-full flex items-center px-3 py-2 text-sm rounded-md group ${item.active ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-305">
                      <div className="flex items-center min-w-0 flex-1" data-id="element-306">
                        <item.icon className={`h-4 w-4 flex-shrink-0 ${item.active ? 'text-blue-600' : 'text-gray-500'}`} data-id="element-307" />
                        <span className="ml-3 truncate" data-id="element-308">{item.name}</span>
                      </div>
                    </button>
                  </li>)}
              </ul>}
          </li>
        </ul>
      </div>
      <div className="p-2 border-t border-gray-200" data-id="element-309">
        <button className="w-full flex items-center justify-center p-2 text-gray-500 hover:bg-gray-100 rounded-md" onClick={() => setCollapsed(!collapsed)} data-id="element-310">
          {collapsed ? <ChevronRightIcon className="h-5 w-5" data-id="element-311" /> : <ChevronLeftIcon className="h-5 w-5" data-id="element-312" />}
          {!collapsed && <span className="ml-2 text-sm" data-id="element-313">Collapse</span>}
        </button>
      </div>
    </div>;
};